export const ThreeDots = {
    template: `<svg viewBox="1 -8 12 20" xmlns="http://www.w3.org/2000/svg">
    <title>pending-ellipses</title>
    <circle cx="2" cy="2" r="1.5"/>
    <circle cx="2" cy="2" r="1.5" transform="translate(5 0)"/>
    <circle cx="2" cy="2" r="1.5" transform="translate(10 0)"/>
</svg>`
}